import { createUseStyles } from 'react-jss'

export const adPreviewScale = 0.8
export const adApprovalsPreviewScale = 0.9
export const adPreviewMinHeight = 320
export const adApprovalsPreviewMinHeight = 340

const useStyles = createUseStyles({
  adPreviewWrapper: {
    height: ({ previewHeight }) => previewHeight || 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    flexGrow: 1,
    marginBottom: 10,
    minHeight: adPreviewMinHeight
  },
  scaledAdPreview: {
    // After scaling the preview, if preview has no content - it's width may collapse, so we set minWidth
    minWidth: '100%',
    transform: ({ isAdApprovalsStyle }) =>
      isAdApprovalsStyle ? `scale(${adApprovalsPreviewScale})` : `scale(${adPreviewScale})`
  }
})

export default useStyles
